export * from './exclude.decorator';
export * from './expose.decorator';
export * from './transform-class-to-class.decorator';
export * from './transform-class-to-plain.decorator';
export * from './transform-plain-to-class.decorator';
export * from './transform.decorator';
export * from './type.decorator';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/class-transformer/esm5/decorators/index.js
// module id = 781
// module chunks = 3